/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 股权质押数量较大
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class StockPledge extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '股权质押情况';
    }

    getColumns = () => {
        return [{
            title: '控股股东累计质押数',
            dataIndex: 'conTotSharepledge'
        }, {
            title: '控股股东累计质押数量占总股本比重',
            dataIndex: 'conTotSharepledgeRatio'
        }, {
            title: '累计质押占总股本比重',
            dataIndex: 'totSharepledgetoStock'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/StockPledge.jsx